import { render } from "./DettaglioVersioneSottoProgetto.vue?vue&type=template&id=a82e2cf6&ts=true"
import script from "./DettaglioVersioneSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./DettaglioVersioneSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__